import React, { FC, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import DeleteConfirmationModal from '../../../sharedModules/layout/DeleteConfirmationModal';

import CertificateSubmissionFullDetail from '../components/CertificateSubmissionFullDetail';
import CertificateSubmissionFields from '../components/CertificateSubmissionFields';
import ExistingAssetsSection from '../components/ExistingAssetsSection';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import NewAssetInput from '../components/NewAssetInput';

import { CertificateSubmission } from '../../model';
import { Customer } from '../../../salesEstimateModules/estimateDetails/model';

import axios from '../../../sharedModules/utils/axios.utils';
import PageHeader from '../../../sharedModules/layout/PageHeader';

const SubmissionDetailPage: FC = () => {
  const { ahriCertificateSubmissionId } = useParams<{ ahriCertificateSubmissionId: string }>();

  const [assetInputOpen, setAssetInputOpen] = useState<boolean>(true);
  const [certificateSubmission, setCertificateSubmission] = useState<CertificateSubmission>();
  const [customer, setCustomer] = useState<Customer>({});
  const [errorMessage, setErrorMessage] = useState('');
  const [requestingCertificate, setRequestingCertificate] = useState(false);

  const fetchCertificateSubmission = async () => {
    try {
      let response: any = await axios.get(`energy_solutions/certificate_submissions/${ahriCertificateSubmissionId}`);
      if (response.data?.result) {
        setCertificateSubmission(response.data.result);
        setCustomer(response.data.result.customer || {});
      }
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something Went Wrong');
    }
  };

  useEffect(() => {
    if (ahriCertificateSubmissionId) {
      fetchCertificateSubmission();
    }
  }, [ahriCertificateSubmissionId]);

  return (
    <Grid container rowSpacing={2}>
      <LoadingWrapper isLoading={!certificateSubmission?.submission_name}>
        <DeleteConfirmationModal refetchParentRecord={fetchCertificateSubmission} />

        <Grid item xs={12}>
          <PageHeader
            mainTitle="Energy Solutions - Submission Details"
            subTitle={`${certificateSubmission?.submission_name} - ${customer?.name}`}
          />
        </Grid>
        <Grid item xs={12}>
          <CertificateSubmissionFields certificateSubmission={certificateSubmission} />
        </Grid>
      </LoadingWrapper>
      <Grid item xs={12}>
        {/* Don't show the Existing Assets Section for a New Customer  */}
        {customer?.id && (
          <ExistingAssetsSection
            customerId={customer?.id}
            submissionId={ahriCertificateSubmissionId}
            fetchCertificateSubmission={fetchCertificateSubmission}
          />
        )}
      </Grid>
      <Grid item xs={12}>
        <NewAssetInput
          assetInputOpen={assetInputOpen}
          certificateSubmission={certificateSubmission}
          setCertificateSubmission={setCertificateSubmission}
          setAssetInputOpen={setAssetInputOpen}
          setRequestingCertificate={setRequestingCertificate}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" color="error">
          {errorMessage}
        </Typography>
      </Grid>
      <LoadingWrapper isLoading={requestingCertificate}>
        <Grid item xs={12}>
          {certificateSubmission && <CertificateSubmissionFullDetail certificateSubmission={certificateSubmission} />}
        </Grid>
      </LoadingWrapper>
    </Grid>
  );
};

export default SubmissionDetailPage;
